import { useEffect, useState } from 'react'
import _ from 'lodash'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { USER_PROPS_ID } from "src/common/razzle-platform-user/ssr"
import { fetchUser } from "src/common/razzle-platform-user/effects"
import { IParamsOption, IRequestFetcherOptions } from 'src/common/razzle-platform-components/types'


type UseUser<T> = {
    user: T,
    isFirstRequestInPregress: boolean
}

export function useUser<T>(options: Pick<IParamsOption, 'params'> = {}): UseUser<T> {
    const params = useParams()
    const dispatch = useDispatch()
    const locale: string = useSelector((state: any) => state.translationModel.locale)
    // get the initial state of userProps by it sheared id
    const initialProps = useSelector((state: any) => state.ssrModel[USER_PROPS_ID]) || {}
    const [isFirstRequestInPregress, setFirstRequestInPregress] = useState(false)
    // we use this state to save our user
    const [state, setState] = useState({ user: initialProps.user })

    useEffect(() => {
        const id = _.get(params, 'id')

        if (initialProps.user) {
            // case when we make reload or refresh on the browser we get the saved user form the server (window.__PRELOADED_STATE__)

            // we remove all initialProps of userProps
            dispatch.ssrModel.cleanInitialProps(USER_PROPS_ID)
        } else {
            // case when we are on browser (pass from page to another) we don't need to get user form the server side

            // we make request if we don't have user or the user it's diffirente to saved user
            if (!state.user || state.user.id !== id) {

                // in user we need params for make forced request exmaple: parms: { _embed: [user, ...etc]}
                const queryOptions: Pick<IRequestFetcherOptions, 'params'> = {
                    params: options.params,
                }

                // set the Accept-Language to the headers of the request for get the translated data
		        const headers = { "Accept-Language": locale }

                const fetchData = async () => {
                    setFirstRequestInPregress(true)
                    // get the user by execute the effect fetchUser and pass it queryOptions
                    const { user } = await fetchUser(id, queryOptions, headers)
                    // save the user in our state
                    setState({ user })
                    setFirstRequestInPregress(false)
                }
                fetchData()
            }
        }

	}, [])

    return { user: state.user, isFirstRequestInPregress }

}

